module.exports = __webpack_public_path__ + "static/media/AMActivo.39744f40.svg";